import { Component, OnDestroy, OnInit } from '@angular/core';
import { timeout } from '../../helpers';
import { ButtonEventsService } from '../../services/button-events.service';
import { CmxLayoutService } from '../../services/cmx-layout.service';
import { LegalEntityService } from '../../services/legal-entity.service';
import { ILegalEntity } from '../../types/legalEntity';

@Component({
  selector: 'cmx-mobile-entity-selector',
  templateUrl: './cmx-mobile-entity-selector.component.html',
  styleUrls: ['./cmx-mobile-entity-selector.component.scss'],
})
export class CmxMobileEntitySelectorComponent implements OnInit, OnDestroy {
  scrollCallback: () => Promise<boolean>;
  selectedEntity: ILegalEntity;

  constructor(
    public legalEntity: LegalEntityService,
    public layout: CmxLayoutService,
    public buttons: ButtonEventsService,
  ) {}

  ngOnInit() {
    this.scrollCallback = this.onScroll.bind(this);
    this.selectedEntity = this.legalEntity.legalEntityActive.getValue();
  }

  preSelect(entity: ILegalEntity) {
    this.selectedEntity = entity;
  }

  async onScroll() {
    this.legalEntity.legalEntityReachedEnd.emit();
    await timeout(200);
    return true;
  }

  cancel() {
    this.layout.isMobileEntitySelectorOpen.next(false);
  }

  apply() {
    this.legalEntity.legalEntityChange.emit(this.selectedEntity.legalEntityId);
    this.layout.isMobileEntitySelectorOpen.next(false);
  }

  ngOnDestroy() {}
}
